<template>
  <div>
    <v-row
      class="mt-4"
      align="center"
      justify="center"
      dark>
      <v-avatar
        :color="color"
        size="65"
      >{{step}}</v-avatar>
    </v-row>
    <v-row
      align="center"
      justify="center"
      dark>
      <v-col
        class="text-center"
        cols="6"
      >
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'TextImageRow',
    props: {
      step: String,
      color: String,
    },
    data: () => ({
    }),
  }
</script>
